<div *ngIf="selectedProgramType !== 'Alumni'" class="w-full  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full flex-column p-4 flex gap-3">
        <h2 class="text-left font-medium text-xl" style="color: #000086;">Rankings</h2>
        <div class="grid align-items-start">
            <div class="col-12 sm:col-4 flex flex-column gap-1 ">
                <p class="font-medium text-base font-semibold text-bluegray-600">QS World Ranking </p>
                <b class="font-semibold text-xl">#{{institute?.qsRanking}}</b>
            </div>
            <div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && institute?.countryRanking"
                class="col-12 sm:col-4 flex flex-column gap-1">
                <p class="font-medium text-base font-semibold text-bluegray-600">UK Ranking</p>
                <b class="font-semibold text-xl">#{{institute?.countryRanking}}</b>
            </div>
            <div *ngIf="selectedProgramType === 'Bachelor\'s Degree'  && institute?.usNewsRanking"
                class="col-12 sm:col-4 flex flex-column gap-1">
                <p class="font-medium text-base font-semibold text-bluegray-600">UK News Ranking</p>
                <b class="font-semibold text-xl">#{{institute?.usNewsRanking}}</b>
            </div>
            <div *ngIf="institute?.subjectRanks && (institute?.subjectRanks | keyvalue)?.length"
                class="col-12 sm:col-4 flex flex-column gap-1 ">
                <p class="font-medium text-base font-semibold text-bluegray-600">Subject Ranks</p>
                <div class="font-semibold text-xl" *ngFor="let subjectRank of institute?.subjectRanks | keyvalue">
                    {{subjectRank.key}}: #{{subjectRank.value}}</div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType !== 'Alumni'" id="divFacilities" class="w-full mt-3 flex flex-column border-1 border-300 border-round-lg p-4 gap-3">
    <h2 class="text-left font-medium text-xl m-0" style="color: #000086;">Facilities</h2>
    <div *ngIf="institute?.facilities?.sportsFacilities || institute?.facilities?.swimmingPool || institute?.facilities?.gym; else noFacilities" 
         class="flex flex-wrap gap-5">
        
        <div *ngIf="institute?.facilities?.sportsFacilities" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-trophy text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Sports Facilities</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

        <div *ngIf="institute?.facilities?.swimmingPool" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-map text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Swimming Pool</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

        <div *ngIf="institute?.facilities?.gym" class="flex flex-column align-items-center gap-2">
            <div class="flex align-items-center justify-content-center border-circle shadow-1" style="width: 3.5rem; height: 3.5rem; background-color: #000086;">
                <i class="pi pi-bolt text-white text-xl"></i>
            </div>
            <div class="text-center">
                <p class="font-bold m-0" style="color: #12263F;">Gym</p>
                <p class="text-sm text-bluegray-400 m-0">Available</p>
            </div>
        </div>

    </div>
    <ng-template #noFacilities>
        <div class="flex align-items-center gap-2 text-bluegray-400 py-2">
            <i class="pi pi-info-circle text-xl"></i>
            <span>No facilities information available.</span>
        </div>
    </ng-template>
</div>

<app-institute-detail-alumni
  *ngIf="selectedProgramType === 'Alumni'"
  [institute]="institute">
</app-institute-detail-alumni>

<div *ngIf="selectedProgramType === 'Bachelor\'s Degree'" id="divAdmissions"
    class="w-full mt-3 flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full p-4 flex flex-column gap-3">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Admissions</h2>
        <div class="w-full flex justify-content-between">
            <div class="flex flex-column gap-1" *ngIf="isUGDetails(instituteUGMDetails)">
                <p class="text-base font-semibold text-bluegray-600">Acceptance Rate</p>
                <b class="text-2xl font-bold">{{ instituteUGMDetails.acceptanceRate ?? 'N/A'}}</b>
            </div>
            <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex flex-column gap-1">
                <p class="text-base font-semibold text-bluegray-600">Application Deadline - Regular Decision</p>
                <b class="text-2xl font-bold">{{ instituteUGMDetails.applicationDeadlineRegularDecision ?? 'N/A'}}</b>
            </div>
        </div>

        <div class="flex gap-3 md:gap-6 flex-column md:flex-row">
            <div class="flex-1 flex flex-column gap-3">
                <div class="flex flex-column">
                    <div *ngIf="isUGDetails(instituteUGMDetails)"
                        class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Application fee 2023</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                            getAmount(instituteUGMDetails.currency, ( instituteUGMDetails.applicationFees ?? '0') ||
                            '0') }}</p>
                    </div>
                    <!-- <div *ngIf="isMastersDetails(instituteUGMDetails)" class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Application fee 2023</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.applicationFees??''}}</p>  
                    </div> -->
                    <!-- <div *ngIf="isUGDetails(instituteUGMDetails)"  class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Application Deadline - Early Action</p>        
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.applicationDeadlineEarlyAction ?? 'N/A'}}</p>
                    </div>   -->
                    <!-- <div *ngIf="isMastersDetails(instituteUGMDetails)"  class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Application Deadline</p>        
                        <p class="text-sm font-medium" style="color: #12263F;">N/A</p>
                    </div>    -->
                </div>
            </div>
            <div class="flex-1 flex flex-column gap-3">
                <div *ngIf="isUGDetails(instituteUGMDetails)" class="flex flex-column">
                    <!-- <div  class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-sm text-bluegray-600">Application Deadline - Early Decision</p>
                        <p class="text-sm font-medium" style="color: #12263F;">{{ instituteUGMDetails.applicationDeadlineEarlyDecisionOne ?? 'N/A'}}</p>
                    </div> -->
                    <div class="flex align-items-center justify-content-between border-y-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">Total Applicants</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                            instituteUGMDetails.totalApplicants === 0 || null ? 'N/A'
                            :instituteUGMDetails.totalApplicants | number }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && isUGDetails(instituteUGMDetails)" id="divCost"
    class="w-full  mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Cost</h2>
        <div class="flex gap-6 flex-column md:flex-row">
            <div class="flex-1 flex flex-column gap-3">
                <div class="flex flex-column gap-3">

                    <div class="flex flex-column gap-1">
                        <p class="text-base font-semibold font-medium text-bluegray-600">Net Price</p>
                        <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                            instituteUGMDetails.averageTutionFees??0) }}</b>
                    </div>
                    <div class="flex flex-column">
                        <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                            <p class="text-base font-semibold text-bluegray-600">On-Campus Room And Board</p>
                            <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                getAmount(instituteUGMDetails.currency,
                                ( instituteUGMDetails.onCampusRoomAndBoard ?? 0) || 0) }}
                            </p>
                        </div>
                        <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                            <p class="text-base font-semibold text-bluegray-600">Off-campus Room and Board</p>
                            <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                getAmount(instituteUGMDetails.currency,
                                ( instituteUGMDetails.offCampusRoomAndBoard ?? 0) || 0) }}</p>
                        </div>
                        <div class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                            <p class="text-base font-semibold text-bluegray-600">Food & Other Expenses</p>
                            <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                getAmount(instituteUGMDetails.currency,
                                ( instituteUGMDetails.foodAndOtherExpenses ?? 0) || 0) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="selectedProgramType === 'Master\'s Degree' && isMastersDetails(instituteUGMDetails)" id="divCost"
    class="w-full  mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Cost</h2>
        <div class="flex gap-6 flex-column md:flex-row">
            <div class="flex-1 flex flex-column gap-3">
                <div class="flex flex-column gap-3">

                    <div class="flex align-items-center justify-content-between gap-2">
                        <div class="flex flex-column gap-1">
                            <p class="text-base font-semibold font-medium text-bluegray-600">Net Price</p>
                            <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                                ( instituteUGMDetails.tutionFees ?? 0) || 0) }}</b>
                        </div>
                        <div *ngIf="institute?.netPriceCalculator && institute?.netPriceCalculator!=''"
                            class="w-auto flex justify-content-end">
                            <a [href]="institute?.netPriceCalculator" target="_blank"
                                class="w-auto font-regular text-sm text-white hover:bg-blue-700 border-round-lg "
                                style="padding: 12px 16px; background-color: #000086;">Net price calculator</a>
                        </div>
                    </div>

                    <div class="flex gap-3 md:gap-6 flex-column  md:flex-row">
                        <div class="flex-1 flex flex-column gap-3">

                            <div class="flex flex-column">

                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                                    <p class="text-base font-semibold text-bluegray-600">Application Fee</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.applicationFees ?? 0) || 0) }}</p>
                                </div>

                                <div
                                    class="flex align-items-center justify-content-between border-top-1 border-300 pt-3">
                                    <p class="text-base font-semibold text-bluegray-600">Food & Housing Charges</p>
                                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{
                                        getAmount(instituteUGMDetails.currency,
                                        ( instituteUGMDetails.combinedFoodAndHousingCharge ?? 0) || 0) }}</p>
                                </div>

                            </div>
                        </div>
                        <div class="flex-1 flex flex-column gap-3">
                            <div class="flex flex-column">
                                <b class="text-left font-bold text-2xl mb-3 " style="color:#101010">Scholarships</b>
                                <a [routerLink]="'/portal/scholarships'"
                                    class="w-full h-3rem border-round-lg text-center font-medium text-base font-semibold link"
                                    style="line-height: 48px;  color: #101010;">Find Scholarship Information</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isUGDetails(instituteUGMDetails)" id="divScholarship"
    class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        @if (scholarships.length > 0) {
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Scholarships</h2>

        <!-- <div class="flex flex-column gap-1">
            <p class="text-base font-semibold font-medium text-bluegray-600">Graduate Schools within</p>
        </div> -->
        @for (item of visibleScholarships; track $index) {
        <div class="flex flex-column gap-2">
            <a class="w-full h-auto px-3 py-2 border-round-lg font-medium text-base font-semibold link_scholarship"
                style="color: #101010; white-space: normal; word-wrap: break-word; background-color: #d1c4e9;">
                {{ item }}
            </a>
        </div>
        }
        <div *ngIf="scholarships.length > 3" class="mt-2 flex justify-content-end">
            <button
                class=" text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                (click)="toggleScholarshipsView()">
                {{ showAllScholarships ? 'Show Less' : 'View All Scholarships' }}
            </button>
        </div>
        }@else {
        <h2 class="text-left text-xl text-bluegray-600 font-medium" style="color: #000086;">Scholarships</h2>
        }
    </div>
</div>


<!-- <div *ngIf="selectedProgramType === 'Master\'s Degree'" id="divScholarship" class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Graduate Schools Within</h2>

        <div class="flex flex-column gap-1">
            <p class="text-base font-semibold font-medium text-bluegray-600">Graduate Schools within</p>
        </div>
        @for (item of (graduateSchoolsWithin).slice(0, 3); track $index) {
            <div class="flex flex-column gap-2">
                <a class="w-full h-3rem px-3 border-round-lg font-medium text-base font-semibold link_scholarship " style="line-height: 48px; color: #101010;">{{item.graduateSchoolName}}</a>    
            </div>
        }
        <p-accordion class="w-full">
            <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
            contentStyleClass="tab_content">
            <div class="flex flex-column gap-3 w-full pt-2">
                @for (item of (graduateSchoolsWithin || []).slice(3); track $index) {
                    <div class="flex flex-column gap-2">
                        <a class="w-full h-3rem px-3 border-round-lg font-medium text-base font-semibold link_scholarship " style="line-height: 48px; color: #101010;">{{item.graduateSchoolName}}</a>    
                    </div>
                }
            </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>  -->



<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' && isUGDetails(instituteUGMDetails)" id="divStudents"
    class="w-full  mt-3 ">
    <div class="grid grid-nogutter border-1 border-300 border-round-lg p-4">
        <div class="md:col-6 col-12 flex flex-column gap-3">
            <h2 class="text-left text-xl font-medium" style="color: #000086;">Student & Enrollments</h2>
            <div class="flex flex-column">
                <div class="flex flex-column gap-1 pb-3">
                    <p class="text-sm text-bluegray-600">Full Time Enrollments</p>
                    <b class="text-2xl font-bold">{{instituteUGMDetails.fullTimeEnrollment === 0 ? 'N/A'
                        :instituteUGMDetails.fullTimeEnrollment | number}} <span
                            class="text-sm text-bluegray-600">Grads</span></b>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">  
                <p class="text-sm text-bluegray-600">Full Time Enrollments</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.fullTimeEnrollment}}</p>
            </div> -->
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-sm text-bluegray-600">Male Enrollment</p>
                    <p class="text-sm font-medium" style="color: #12263F;">
                         {{ formatPercent(instituteUGMDetails.maleEnrollment) }}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-sm text-bluegray-600">Female Enrollment</p>
                    <p class="text-sm font-medium" style="color: #12263F;">
                          {{ formatPercent(instituteUGMDetails.femaleEnrollment) }}</p>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">International Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.internationStudentsEnrollment}}</p>
            </div> -->
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">UK Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.uk}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">EU Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.eu}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Other Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.others}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Postgraduate Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.postGraduate}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Undergraduate Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.underGraduate}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Full time male undergraduate enrollment</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.fullTimeUndergraduateMaleEnrollment}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Full time female undergraduate enrollment</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.fullTimeUndergraduateFemaleEnrollment}}</p>
            </div> -->
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-sm text-bluegray-600">Indian Students Enrolled</p>
                    <p class="text-sm font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.fullTimeUnderGraduateIndianStudents}}</p>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Part-time students enrollment</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.partTimeStudentEnrollment}}</p>
            </div>   -->
            </div>
        </div>
        <div class="md:col-6 col-12 pt-4 md:pt-0">
            <div class="flex flex-column md:flex-row align-items-center justify-content-center gap-4 w-full">
                <!-- First Pie Chart -->
                <div class="w-full md:w-6">
                    @if(pieData) {
                    <p-chart #chart1 type="pie" [data]="pieData" [options]="pieOptions"></p-chart>
                    }
                </div>

                <!-- Second Pie Chart -->
                <div class="w-full md:w-6">
                    @if(pieDataUMG) {
                    <p-chart #chart2 type="pie" [data]="pieDataUMG" [options]="pieOptionsUMG"></p-chart>
                    }
                </div>
            </div>
        </div>
        <!-- <div class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
            @if(pieData){
            <p-chart type="pie" [data]="pieData" [options]="pieOptions" />
            }
        </div>
        <div class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
            @if(pieDataUMG){
            <p-chart type="pie" [data]="pieDataUMG" [options]="pieOptionsUMG" />
            }
        </div> -->
    </div>
</div>

<div *ngIf="selectedProgramType === 'Master\'s Degree' && isMastersDetails(instituteUGMDetails)" id="divStudents"
    class="w-full  mt-3 ">
    <div class="grid grid-nogutter border-1 border-300 border-round-lg p-4">
        <div class="md:col-6 col-12 flex flex-column gap-3">
            <h2 class="text-left text-xl font-medium" style="color: #000086;">Student & Enrollments</h2>
            <div class="flex flex-column">
                <div class="flex flex-column gap-1 pb-3">
                    <p class="text-base font-semibold text-bluegray-600">Graduate Enrollments</p>
                    <b class="text-2xl font-bold">{{instituteUGMDetails.graduateStudentsEnrolled === 0 ? 'N/A'
                        :instituteUGMDetails.graduateStudentsEnrolled | number}} <span
                            class="text-sm text-bluegray-600">Grads</span></b>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">  
                <p class="text-sm text-bluegray-600">Full Time Enrollments</p>
                <p class="text-sm font-medium" style="color: #12263F;">N/A</p>
            </div> -->
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Male Graduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                         {{ formatPercent(instituteUGMDetails.maleEnrollment) || 'N/A'}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Female Graduate Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{ formatPercent(instituteUGMDetails.femaleEnrollment) || 'N/A'}}</p>
                </div>
                <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Part-time students enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.partTimeEnrollment | number}}</p>
                </div>
                <div *ngIf="instituteUGMDetails.totalEnrollment"
                    class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Total Enrollment</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">
                        {{instituteUGMDetails.totalEnrollment}}</p>
                </div>
                <div *ngIf="instituteUGMDetails.scholarships?.length"
                    class="flex flex-column gap-1 border-top-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">Scholarships</p>
                    <ul class="m-0 pl-3">
                        <li *ngFor="let scholarship of instituteUGMDetails.scholarships"
                            class="text-sm font-medium" style="color: #12263F;">{{scholarship}}</li>
                    </ul>
                </div>
                <!-- <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">International Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.internationalStudents}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">UK Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.uk}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">EU Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.eu}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Other Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.others}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Postgraduate Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.postGraduate}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Undergraduate Students</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.underGraduate}}</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Full time male undergraduate enrollment</p>
                <p class="text-sm font-medium" style="color: #12263F;">N/A</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Full time female undergraduate enrollment</p>
                <p class="text-sm font-medium" style="color: #12263F;">N/A</p>
            </div>
            <div class="flex align-items-center justify-content-between border-top-1 border-300 py-3">
                <p class="text-sm text-bluegray-600">Indian postgraduate students enrollment</p>
                <p class="text-sm font-medium" style="color: #12263F;">{{instituteUGMDetails.fullTimeIndianPostGraduateStudents}}</p>
            </div> -->

            </div>
        </div>
        <div class="md:col-6 col-12 pt-4 md:pt-0">
            <div class="flex flex-column md:flex-row align-items-center justify-content-center gap-4 w-full">
                <!-- First Pie Chart -->
                <div class="w-full md:w-6">
                    @if(pieData) {
                    <p-chart type="pie" [data]="pieData" [options]="pieOptions"></p-chart>
                    }
                </div>

                <!-- Second Pie Chart -->
                <div class="w-full md:w-6">
                    @if(pieDataUMG) {
                    <p-chart type="pie" [data]="pieDataUMG" [options]="pieOptionsUMG"></p-chart>
                    }
                </div>
            </div>
        </div>
        <!-- <div class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
        @if(pieData){
        <p-chart type="pie" [data]="pieData" [options]="pieOptions" />
        }
    </div>
    <div class="md:col-6 col-12 pt-4 md:pt-0 flex flex-column align-items-center justify-content-center">
        @if(pieDataUMG){
        <p-chart type="pie" [data]="pieDataUMG" [options]="pieOptionsUMG" />
        }
    </div> -->
    </div>
</div>

<div *ngIf="selectedProgramType === 'Master\'s Degree'" id="divScholarship"
    class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        @if (graduateSchoolsWithin.length > 0) {
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Graduate Schools Within</h2>

        <!-- <div class="flex flex-column gap-1">
            <p class="text-base font-semibold font-medium text-bluegray-600">Graduate Schools within</p>
        </div> -->
        @for (item of visibleGraduateSchoolsWithin; track $index) {
        <div class="flex flex-column gap-2">
            <a class="w-full h-3rem px-3 border-round-lg font-medium text-base font-semibold link_scholarship "
                style="line-height: 48px; color: #101010;">{{item.graduateSchoolName}}</a>
        </div>
        }
        <div *ngIf="graduateSchoolsWithin.length > 3" class="mt-2 flex justify-content-end">
            <button
                class=" text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                (click)="toggleGraduateSchoolsView()">
                {{ showAllGraduateSchoolsWithin ? 'Show Less' : 'View All Graduate Schools' }}
            </button>
        </div>
        }@else {
        <h2 class="text-left text-xl text-bluegray-600 font-medium" style="color: #000086;">No Graduate Schools Within!
        </h2>
        }
    </div>
</div>


<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' " id="divAcademics"
    class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Academics</h2>
        <div class="flex flex-column sm:flex-row gap-1 align-content-center md:gap-3">
            <a (click)="triggerDisplayCourses()" class="h-3rem flex-1 text-center border-round-lg link_aa"
                style="line-height: 48px; color: #fff;">Find Undergraduate Courses</a>
            <a (click)="triggerDisplayCourses()" class="h-3rem flex-1 text-center border-round-lg link_aay"
                style="line-height: 48px; color: #101010;">Find Graduate Courses</a>
        </div>
    </div>
</div>


<div *ngIf="selectedProgramType === 'Bachelor\'s Degree' || selectedProgramType === 'Master\'s Degree'" id="divMajors"
    class="w-full  mt-3 flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="w-full p-4 flex flex-column gap-3">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">Majors</h2>
        <div *ngIf="selectedProgramType === 'Bachelor\'s Degree'">
            @if (instituteBachelorMajors.length > 0) {
            <h1 class="text-left text-2xl font-bold">Most Popular Undergraduate Majors</h1>
            <div class="flex flex-column">
                @for (major of visibleUGMajors ; track $index) {
                <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates |
                        number}} Graduates</p>
                </div>
                }

                <!-- <div class="flex align-items-center justify-content-between border-300 pt-3">
                <p-accordion class="w-full">
                    <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                    contentStyleClass="tab_content">
                    <div class="flex flex-column pt-3 ">
                    @for (major of (instituteBachelorMajors || []).slice(3); track major) {
                        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates  | number}} Graduates</p>
                        </div>
                    }
                    </div>
                    </p-accordionTab>
                </p-accordion>
                </div> -->
            </div>
            <div *ngIf="instituteBachelorMajors.length > 3" class="mt-2 flex justify-content-end">
                <button
                    class=" py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                    (click)="toggleMajorsView('UG')">
                    {{ showAllUGMajors ? 'Show Less' : 'View All Majors' }}
                </button>
            </div>
            }@else {
            <h1 class="text-left text-2xl mt-1 font-bold text-bluegray-600">No Undergraduate Majors Available!</h1>
            }
        </div>
        <div *ngIf="selectedProgramType === 'Master\'s Degree'">
            @if (instituteGraduateMajors.length > 0) {
            <h1 class="text-left text-2xl font-bold">Most Popular Postgraduate Majors</h1>
            <div class="flex flex-column">
                @for (major of visiblePGMajors ; track $index) {
                <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates |
                        number}} Graduates</p>
                </div>
                }
                <!-- <div class="flex align-items-center justify-content-between border-300 pt-3">
                <p-accordion class="w-full">
                    <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                    contentStyleClass="tab_content">
                    <div class="flex flex-column pt-3 ">
                    @for (major of (instituteGraduateMajors || []).slice(3); track major) {
                        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates | number}} Graduates</p>
                        </div>
                    }
                    </div>
                    </p-accordionTab>
                </p-accordion>
                </div> -->
            </div>
            <div *ngIf="instituteGraduateMajors.length > 3" class="mt-2 flex justify-content-end">
                <button
                    class=" py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                    (click)="toggleMajorsView('PG')">
                    {{ showAllPGMajors ? 'Show Less' : 'View All Majors' }}
                </button>
            </div>
            }@else {
            <h1 class="text-left text-2xl mt-1 font-bold text-bluegray-600">No Postgraduate Majors Available!</h1>
            }

            @if (instituteDoctoralMajors.length > 0) {
            <h1 class="text-left text-2xl mt-1 font-bold">Most Popular Doctoral Majors</h1>
            <div class="flex flex-column">
                @for (major of visibleDoctoralMajors ; track major) {
                <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                    <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                    <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates |
                        number}} Graduates</p>
                </div>
                }
                <!-- <div class="flex align-items-center justify-content-between border-300 pt-3">
                <p-accordion class="w-full">
                    <p-accordionTab header="More" iconPos="end" headerStyleClass="header_tab"
                    contentStyleClass="tab_content">
                    <div class="flex flex-column pt-3 ">
                    @for (major of (instituteDoctoralMajors || []).slice(3); track major) {
                        <div class="flex align-items-center justify-content-between border-bottom-1 border-300 py-3">
                        <p class="text-base font-semibold text-bluegray-600">{{major.fieldOfStudy}}</p>
                        <p class="text-base font-semibold font-medium" style="color: #12263F;">{{major.numberOfGraduates | number}} Graduates</p>
                        </div>
                    }
                    </div>
                    </p-accordionTab>
                </p-accordion>
                </div> -->
            </div>
            <div *ngIf="instituteDoctoralMajors.length > 3" class="mt-2 flex justify-content-end">
                <button
                    class=" py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                    (click)="toggleMajorsView('Doctoral')">
                    {{ showAllDoctoralMajors ? 'Show Less' : 'View All Majors' }}
                </button>
            </div>
            }@else{
            <h1 class="text-left text-2xl mt-1 font-bold text-bluegray-600">No Doctoral Majors Available!</h1>
            }
        </div>

    </div>
</div>


<div *ngIf="selectedProgramType !== 'Alumni'" id="divAfterCollege" class="w-full mt-3  flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
        <h2 class="text-left text-xl font-medium" style="color: #000086;">After College</h2>
        <div class="grid grid-nogutter align-items-end">
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Median Earnings after 1 year</p>
                <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.medianEarningsOfGraduatesWorkingPostOneYearCompletion ?? 0) || 0) }} <span class="text-sm text-bluegray-600"> / per year</span></b>
            </div>
        </div> -->
            <div class="md:col-8 col-12">
                <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                    <p class="text-base font-semibold text-bluegray-600">Popular Employers</p>
                    <b class="text-xl font-bold">{{popularEmployers ? popularEmployers: 'N/A'}}</b>
                </div>
            </div>
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Median Earnings after 5 years </p>
                <b class="text-2xl font-bold">{{ getAmount(instituteUGMDetails.currency,
                    ( instituteUGMDetails.medianEarningsOfGraduatesWorkingPostFiveYearCompletion ?? 0) || 0) }}<span class="text-sm text-bluegray-600"> / per year</span></b>
            </div>
        </div> -->
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Graduation rate for international students 2023 </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.internationalStudentsGraduationRate}}</b>
            </div>
        </div> -->
            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Graduation rate for total cohort </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.totalCohortGraduationRate}}</b>
            </div>
        </div> -->

            <!-- <div *ngIf="isUGDetails(instituteUGMDetails)" class="md:col-4 col-12">
            <div class="flex flex-column gap-1 pb-3 md:pb-0 md:pr-3">
                <p class="text-sm text-bluegray-600">Students earning more than a high school graduate (threshold earnings) 11 years after entry </p>
                <b class="text-2xl font-bold">{{instituteUGMDetails.percentEarningAboveHighSchool11Years}}</b>
            </div>
        </div> -->
            <div class="md:col-4 col-12 flex justify-content-end">
                <a [routerLink]="'/portal/peer'" class="h-3rem block flex-1 text-center border-round-lg link_aay"
                    style="line-height: 48px; color: #101010;">Connect with Alumni</a>
            </div>
        </div>
    </div>
</div>